/* Accessible Amazon-style mobile image dots, using Dawn's existing media gallery. */
if (!customElements.get('ldm-gallery-dots')) {
  customElements.define('ldm-gallery-dots', class LdmGalleryDots extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this.gallery = this.closest('media-gallery');
      this.viewer = this.gallery?.querySelector('[id^="GalleryViewer-"]');
      this.slider = this.viewer?.querySelector('[id^="Slider-Gallery-"]');
      if (!this.slider) { this.hidden = true; return; }
      this.slides = Array.from(this.slider.querySelectorAll('.product__media-item[data-media-id]'));
      if (this.slides.length < 2) { this.hidden = true; return; }
      this._initialized = true;
      const fragment = document.createDocumentFragment();
      this.slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ldm-gallery-dot';
        button.setAttribute('aria-label', 'Show product image ' + (index + 1) + ' of ' + this.slides.length);
        button.addEventListener('click', () => {
          if (typeof this.gallery?.setActiveMedia === 'function') {
            this.gallery.setActiveMedia(slide.dataset.mediaId, false);
          } else {
            this.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
          this.markActive(index);
        });
        fragment.append(button);
      });
      this.replaceChildren(fragment);
      this.dots = Array.from(this.querySelectorAll('.ldm-gallery-dot'));
      this.onGalleryScroll = () => this.update();
      this.slider.addEventListener('scroll', this.onGalleryScroll, { passive: true });
      this.viewer?.addEventListener('slideChanged', this.onGalleryScroll);
      this.resizeObserver = new ResizeObserver(this.onGalleryScroll);
      this.resizeObserver.observe(this.slider);
      this.update();
    }
    disconnectedCallback() {
      this.slider?.removeEventListener('scroll', this.onGalleryScroll);
      this.viewer?.removeEventListener('slideChanged', this.onGalleryScroll);
      this.resizeObserver?.disconnect();
      this._initialized = false;
    }
    markActive(index) {
      this.dots?.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    update() {
      if (!this.slides?.length || !this.slider) return;
      const left = this.slider.scrollLeft;
      let index = 0, closest = Infinity;
      this.slides.forEach((slide, i) => {
        const distance = Math.abs(slide.offsetLeft - left);
        if (distance < closest) { closest = distance; index = i; }
      });
      this.markActive(index);
    }
  });
}
